import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '@app/core/services/api.service';
import { map } from 'rxjs/operators';

export interface IdentityContext {
  ssn: string;
  dob: string;
}

@Injectable()
export class IdentityService {
  constructor(
    private apiService: ApiService,
  ) { }

  isParticipant(context: IdentityContext): Observable<any> {
    const data = { 'ssn': context.ssn, 'dob': context.dob };
    return this.apiService.post('/identity', data)
      .pipe(
        map(
          res => {
            //console.log("response" + res);
            return res
          },
          err => {
            console.log("error response" + err);
          }
        )
      );
  }

  blockWebAccess(context: IdentityContext): Observable<any> {
    const data = { 'ssn': context.ssn, 'dob': context.dob };
    return this.apiService.post('/block', data)
      .pipe(
        map(
          res => {
            //console.log("response" + res);
            return res
          },
          err => {
            console.log("error response" + err);
          }
        )
      );
  }
  sendUsername(context: IdentityContext): Observable<any> {
    const data = { 'ssn': context.ssn, 'dob': context.dob };
    return this.apiService.post('/forgot/username', data)
      .pipe(
        map(
          res => {
            //console.log("response" + res);
            return res
          },
          err => {
            console.log("error response" + err);
          }
        )
      );
  }
  sendPasswordLink(context: IdentityContext): Observable<any> {
    const data = { 'ssn': context.ssn, 'dob': context.dob };
    return this.apiService.post('/forgot/password', data)
      .pipe(
        map(
          res => {
            //console.log("response" + res);
            return res
          },
          err => {
            console.log("error response" + err);
          }
        )
      );
  }
}
